<template lang="pug">
  v-card.mx-auto.mt-0(outlined max-width='100%' :style="isMobile ? 'padding: 5px !important' : '' ").basket
    //-
      v-dialog( v-if='loginDialog' max-width='380'  origin  v-model="loginDialog")
        login(userType="customer"  @close="loginDialog = false" @switchDialog="switchDialog('register')")
      v-dialog( v-if='registerDialog' origin  v-model="registerDialog")
        register(userType="customer"  @close="registerDialog = false" @switchDialog="switchDialog('login')")
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-layout.basket__list
      template(v-if="arrCart.inventory.length > 0")
        div(cols='12')
          //-
            v-btn(color="#009da5" fab small dark="" v-if="isMobile" @click="$router.go(-1)").mt-2.ml-2 <!-- i === 0 && !paymentWizzardDialog-->
              v-icon(size="25") mdi-arrow-left
          p(class="shop-title") {{arrCart.name}}
          p(v-if="+arrCart.subtotal < +arrCart.minOrderValue " style="padding: 10px; font-size: 15px; color: red") {{'Debes pedir minimo: $ ' + arrCart.minOrderValue + ' para continuar con tu orden'}}
          //- p(style="padding: 10px; font-size: 15px") {{'Total: ' + arrCart.subtotal}}
          v-row.pl-3
            p(style="padding: 10px; font-size: 15px") {{'Metodo de pago: ' }}
            v-chip-group(v-model="account"  column active-class="primary--text")
              v-chip(v-for="accountOpt in accounts"  :key="accountOpt.type")
                v-icon(medium="" v-text="accountOpt.icon")
                span {{ accountOpt.type }}
          v-row.pl-3
            p(style="padding: 10px; font-size: 15px") {{'Opción de entrega: '}}
            v-chip-group( v-model="selectedDelivery" column active-class="primary--text")
              v-chip(v-for="(delivery, i) in deliveryOptions" @click="setDeliveryOption(i)" :key="delivery.type")
                v-icon(medium="" v-text="delivery.icon")
                span {{ delivery.type }}
          v-row.justify-center
            form(style="width: 80%;")
              v-responsive.mx-auto(max-width="500")
                v-col(cols="12" v-if="arrCart.delivery === 'delivery'")
                  p.font-weight-bold(v-if="arrCart.deliveryCost > -1") {{'Costo del domicilio: ' }} {{arrCart.deliveryCost | numberFormat}}
                  p(v-if="disbaledAutGoogle") Dirección
                  gmap-autocomplete(@place_changed="setPlace" v-if="disbaledAutGoogle" :options="autocompleteOptions" class="border-location input--google" validate-on-blur="" placeholder="Introduce tu dirección").location-input
                  v-row.justify-center.pa-3()
                    p Mis direcciones:
                  v-row.justify-center.pa-3()
                    v-chip-group(v-model="selectedChip" column active-class="primary--text")
                      v-chip.mr-2(@click="gpsAddress.direction ? setAddress(gpsAddress) : ''" :style="gpsAddress.direction ? '': 'pointer-events: none'")
                        img(src="@/assets/images/location-icon.png")
                        span.ml-2.video-card__location(v-if="gpsAddress.direction") {{gpsAddress.direction}}
                        span.ml-2.video-card__location(v-else) No podemos acceder a tu ubicación
                      v-chip(v-for="location in userLocations" @click="setAddress(location)" :key="location.direction")
                        | {{ location.direction }}
                v-col.justify-center.pa-4(v-if="arrCart.delivery === 'pickup'")
                  v-row.mb-2()
                    p Direccion del  establecimiento:
                  v-row.mb-2
                    //- p {{arrCart.name + ':   ' + arrCart.addressInfo.addressgoogle}}
                    p {{arrCart.addressInfo.addressgoogle}}
          v-card-text.text--primary()
            v-col().cart__section
              v-row(v-for='(product, j) in arrCart.inventory' :key='j' cols='12' md="4" v-if="product")
                v-col(cols="2" style="padding: 0px 0px 10px 10px;")
                  v-img(style="width: 50px; height: 50px;" :src='getImage(product.data.pictures.imageInput1)')
                v-col(cols="7" style="padding: 0px 0px 10px 10px;")
                  p(style="font-size:'16px' padding-left: 25px;     margin-bottom: 10px;") {{product.data.name}}
                  <!--p(style="padding-left: 25px;     margin-bottom: 0px;") $ {{getPrice(product)}} Stock: {{product.data.location[arrCart.id].stock}}-->
                  b(style= "font-size: 18px; margin-bottom: 0px;") $ {{getPrice(product) | numberFormat}}{{product.data.magnitude ? ' x ' + product.data.unit : ''}}
                v-col(cols="3" style="padding: 0px 0px 10px 10px;")
                  v-row
                    v-btn(icon='' color='primary' @click="quitAmount(cartPosition,j,arrCart.id, product)")
                      v-icon mdi-minus
                    p(v-if="!product.data.magnitude" style="padding: 2px; padding-top: 10px; margin-bottom: 0px;") {{product.amount}}
                    v-text-field(v-else v-model="product.data.newAmount" style="max-width: 50px;margin: 0;padding: 0;" :rules="[rules.number, rules.minValue]" @change="updateAmount(cartPosition, j, arrCart.id, product)")
                    v-btn(icon='' color='primary' @click="addAmount(cartPosition,j,arrCart.id, product)")
                      v-icon mdi-plus
                  v-row
                    span.mr-1(style="font-size: 14px") Total
                    b $ {{getPrice(product) * product.amount | numberFormat}}
                hr(style="width: 100%;")
          //-
            v-row.justify-center(v-if="!first_buy_done")
              v-col(cols="8")
                h3() Es tu primera compra, recibe tu cupón de primera compra aqui:
              v-col.justify-center(cols="3" style="display: flex")
                v-dialog(v-model="firstCouponDialog" persistent="" max-width="600px")
                  template(v-slot:activator="{ on, attrs }")
                    v-btn(color="primary" dark="" v-bind="attrs" v-on="on" style="padding: 5px !important") Obtener Cupón
                  v-card
                    v-card-title
                      span.headline Obtener Cupón Primera compra
                    v-card-text
                      v-container
                        v-form(ref="form" v-model="valid" lazy-validation="")
                          v-card-subtitle
                            | Ingrese aqui el codigo de la persona que le recomendo TENDER si no tiene codigo de referido presione no he sido referido.
                          v-text-field(v-model="referralCode" label="Código de referido" required="")
                          v-btn.mr-4(:disabled="loadingReferral" :loading="loadingReferral" color="success" @click="addReferralCoupon")
                            | Validar Referido
                          v-btn.mr-4(color="secondary" @click="dontHaveReferral")
                            | No he sido referido
          //-
            div(v-if="coupon && coupon.availableShop === arrCart.id && userProfile")
              v-row
                v-col(cols="6")
                  h2
                    | {{coupon.title}}
                v-col(cols="4")
                  h2 $ {{ coupon.value | numberFormat }}
                v-col(cols="2")
                  v-btn.mx-2(fab="" small dark="" color="red" @click="deleteCoupon")
                    v-icon(dark="") mdi-delete
          //-
            div(v-else-if="!coupon && userProfile" flex)
              v-row.justify-center
                v-col.align-center(cols="8" style="display: flex")
                  h3
                    | No ha seleccionado ningún cupón
                v-col.justify-center(cols="3" style="display: flex")
                  v-dialog(v-model="coupondialog" width="500")
                    template(v-slot:activator="{ on, attrs }")
                      v-btn.mx-2(fab="" small dark="" @click="getAvailableCoupons" color="primary" v-bind="attrs" v-on="on")
                        v-icon(dark="") mdi-plus
                    v-card
                      v-card-title.headline.grey.lighten-2(primary-title="")
                        | Cupones
                      v-card-text(v-if="loadingcoupons")
                        v-row
                          v-col(cols="5")
                          v-col
                            v-progress-circular(:size="70" :width="7" color="primary" indeterminate="" centered)
                      v-card-text(v-else)
                        v-row
                          h1(center)
                            | Selecciona un cupón
                          NoResults(v-else v-if="coupons.length === 0" title='No tienes cupones', description='Invita a tus amigos a usar Tender con tu código de referido y gana cupones')
                        v-row
                          v-list(two-line="" flex)
                            v-list-item-group(v-model="selectedCoupon" active-class="primary--text")
                              template(v-for="(item, index) in coupons")
                                v-list-item(:key="item.title")
                                  template(v-slot:default="{ active, toggle }")
                                    v-list-item-content
                                      v-list-item-title(v-text="item.title")
                                      v-list-item-subtitle.text--primary(v-text="item.headline")
                                      v-list-item-subtitle(v-text="item.details")
                                    v-list-item-action
                                      v-list-item-action-text(v-text="item.value")
                                      v-icon(v-if="!active" color="grey lighten-1")
                                        | star_border
                                      v-icon(v-else="" color="yellow")
                                        | star
                                v-divider(v-if="index + 1 < coupons.length" :key="index")
                      v-divider
                      v-card-actions
                        v-spacer
                        v-btn(color="red" text="" @click="coupondialog = false")
                          | Cancelar
                        v-btn(color="primary" text="" @click="saveSelectedCoupon")
                          | Aplicar Cupón
      div(v-else)
        NoResults(title='No tienes productos en tu canasta', description='Visita una tienda y agrega productos a tu canasta')
      v-card-actions(:class="$route.name === 'cart' ? 'isCart' : ''").basket-btn__container.modal-cart
        v-row() <!-- v-if="!isMobile" -->
          v-col(cols='10')
            v-btn(color='#009da5' rounded style="width: 100%;pointer-events: none;").basket-btn.text-capitalize
              v-col.ml-4.py-2.px-4(cols="auto" style="font-size: 18px; text-align: center;  background: #1F7087")
                | {{totalProducts.toFixed(0)}}
              v-col(cols="auto"  style="text-align: center; padding-top: 0px;").pa-2.mx-4
                span(style="color: white; font-size: 1.6rem") Total
              v-col.mr-4(cols="auto" style="font-size: 18px; text-align: right; padding-top: 0px;").pa-2
                | $ {{totalPrice | numberFormat}}
          v-col(cols="2" :style=" isMobile ? 'padding-left: 0px !important;' : '' ")
            v-tooltip(bottom="")
              template(v-slot:activator="{ on, attrs }")
                v-btn(fab small color="red" @click="clearCart" v-bind="attrs" v-on="on")
                  v-icon.rounded mdi-delete
              span Limpiar carrito
          v-col
            v-btn(color="primary" :loading="loading" :disabled="invalidCart(arrCart) || loading" @click="chooseOrderType(arrCart)") pagar
        //-
          v-row(v-if="isMobile").justify-center
            a(@click="openBasket" style="width: 88%;").basket__continue-btn
              v-btn(color="white" fab height="20" width="20").mx-0.px-0.mr-2
                v-icon(color="#009da5") mdi-arrow-right
              p.d-inline Continuar
              p.basket__product-number {{totalProducts.toFixed(0)}}
              p.basket__total $ {{totalPrice | numberFormat}}
</template>
<script>
// import { mapActions } from 'vuex'
  import imgCart from '@/assets/images/background-tender.png'
  import productPlaceHolder from '@/assets/icons/products.png'
  import Swal from 'sweetalert2'
  import * as vars from '@/vars.json'
  import moment from 'moment'
  import axios from 'axios'
  const geocoding = require('reverse-geocoding-google')
  // import Vue from 'vue'
  export default {
    components: {
      productPlaceHolder: productPlaceHolder,
      PaymentWizzard: () => import('./PaymentWizzard'),
      login: () => import('@/views/pages/Login'),
      register: () => import('@/views/pages/Register'),
      PreviewBasket: () => import('@/views/marketplace/components/PreviewBasket'),
      NoResults: () => import('@/components/custom/NoResults.vue'),
    },
    filters: {
      numberFormat (val) {
        if (val) {
          const fixed = Number.parseFloat(val).toFixed(0)
          return fixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        } else return '0'
      },
    },
    props: {
      currentShopId: String,
    },
    data () {
      return {
        rules: {
          number: value => {
            return /^[0-9]+([,.][0-9]+)?$/g.test(value) || 'Cifra invalida.'
          },
          minValue: value => {
            return value >= 1 || 'Valor minimo debe ser igual a 1'
          },
        },
        referralCode: '',
        firstCouponDialog: false,
        // loginDialog: false,
        registerDialog: false,
        currentCartArr: [],
        paymentModal: false,
        loading: false,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        dialogBasket: false,
        imgCart: imgCart,
        totalProducts: 0,
        totalPrice: 0,
        arrProducts: [],
        arrCart: {
          inventory: [],
        },
        selectedCoupon: null,
        coupondialog: false,
        valid: false,
        loadingReferral: false,
        loadingcoupons: false,
        allAboveMinimum: true,
        allvalidInputAmount: true,
        cartPosition: -1,
        selectedDelivery: '',
        gpsAddress: {},
        selectedChip: '',
        autocompleteOptions: {
          componentRestrictions: {
            country: [
              'co',
            ],
          },
        },
        selectedLat: 0,
        selectedLng: 0,
        address: '',
        disbaledAutGoogle: true,
        account: '',
        accounts: [
          {
            icon: 'mdi-cash',
            type: 'Efectivo',
          },
          {
            icon: 'mdi-cash',
            type: 'Mercado pago',
          },
          {
            icon: 'mdi-cash',
            type: 'Datáfono',
          },
        ],
        deliveryOptions: [
          {
            // -icon: require('@/assets/icons/delivery/delivery-man.png'),
            icon: 'mdi-cash',
            type: 'Domicilio',
          },
          {
            // -icon: require('@/assets/icons/delivery/shop.png'),
            icon: 'mdi-cash',
            type: 'Buscar en el establecimiento',
          },
        ],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      coupon () {
        return this.$store.getters['promotions/getCoupon']
      },
      coupons () {
        return this.$store.getters['referrals/getCoupons']
      },
      cart () {
        return this.$store.getters['pos/getCart']
      },
      userProfile () {
        return this.$store.getters['users/getProfile']
      },
      /* paymentWizzardDialog () {
        return true // this.$store.getters['dialogs/getPaymentWizzardDialog']
      }, */
      first_buy_done () {
        const vm = this
        if (vm.userProfile) {
          return vm.userProfile.first_buy_done
        } else {
          return true // como no estas logeado no deben salir los cupones
        }
      },
      referral () {
        return this.$store.getters['promotions/getReferral']
      },
      addedCoupon () {
        return this.$store.getters['promotions/getAddedCoupon']
      },
    },
    watch: {
      selectedChip (newVal, oldVal) {
        const vm = this
        // console.log(newVal)
        if (newVal >= 0) {
          vm.disbaledAutGoogle = false
        } else {
          vm.address = ''
          vm.disbaledAutGoogle = true
        }
      },
      cart (newVal, oldVal) {
        this.arrCart = newVal.filter(el => el.id === this.currentShopId)[0]
        if (!this.arrCart) {
          this.arrCart = {
            inventory: [],
            delivery: 'delivery',
          }
        } else {
          this.cartPosition = newVal.findIndex(el => el.id === this.currentShopId)
          this.getDataCart()
        }
      },
      /* 'arrCart.delivery' (newVal, oldVal) {
        const vm = this
        if (newVal === 'pickup') {
          vm.arrCart.deliveryCost = -1
          vm.getDataCart()
          vm.loading = false
        }
      }, */
    },
    created () {
      this.arrCart = this.cart.filter(el => el.id === this.currentShopId)[0]
      if (!this.arrCart) {
        this.arrCart = {
          inventory: [],
          delivery: 'delivery',
        }
      } else {
        this.cartPosition = this.cart.findIndex(el => el.id === this.currentShopId)
      }
    },
    mounted () {
      this.imgShop = 'https://cdn.vuetifyjs.com/images/cards/docks.jpg'
      this.getDataCart()
    },
    methods: {
      invalidCart (cart) {
        const vm = this
        if (
          cart.inventory.length === 0 ||
          !vm.allvalidInputAmount ||
          !vm.allAboveMinimum ||
          (!vm.selectedDelivery && vm.selectedDelivery !== 0) ||
          (!vm.account && vm.account !== 0)) {
          return true
        }

        if (!vm.userProfile) {
          // vm.loginDialog = true
          this.$store.dispatch('dialogs/openDialog', 'login').then(function () {
            // console.log('dialog set on : ' + 'login')
          })
          return true
        } else if (vm.address === '' && cart.delivery === 'delivery') {
          // es invalido y no se hace nada
          return true
        } else {
          return false
        }
      },
      chooseOrderType () {
        const vm = this
        if (vm.account === 0) { // efectivo
          vm.sendOrder(vm.arrCart)
        } else if (vm.account === 1) { // mercado pago
          // vm.sendOrder(vm.arrCart)
          // console.log('cargando mercadopago chekcout')
          axios.post(vars.url + '/checkoutMercadoPago', { items: vm.arrCart.inventory, ownerId: vm.arrCart.uid }).then(res => {
            // console.log(res.data, 'termine checkout')
            window.location.replace(res.data)
            /* const mpScript = document.createElement('script')
            mpScript.setAttribute('src', 'https://www.mercadopago.com.co/integrations/v1/web-payment-checkout.js')
            mpScript.setAttribute('data-preference-id', res.data)
            document.head.appendChild(mpScript) */
          }).catch(error => {
            console.log(error, 'error mercado pago')
          })
        } else { // datafono account === 2
          vm.sendOrder(vm.arrCart) // por ahora no hace nada diferente a efectivo
        }
      },
      userLocations () {
        const vm = this
        if (vm.userProfile) {
          const locations = vm.userProfile.locations
          const locationsText = []
          if (locations) {
            for (const key in locations) {
              if (Object.prototype.hasOwnProperty.call(locations, key)) {
                const location = locations[key]
                locationsText.push(location)
              }
            }
            return locationsText
          } else if (vm.userProfile.defaultlocation) {
            locationsText.push(vm.userProfile.defaultlocation)
            return locationsText
          } else {
            return []
          }
        } else {
          return []
        }
      },
      setAddress (location) {
        const vm = this
        // console.log(location)
        vm.address = location.direction
        vm.selectedLng = location.location.lng
        vm.selectedLat = location.location.lat
      },
      geolocate () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          // console.log(position)
          const latitude = position.coords.latitude
          const longitude = position.coords.longitude
          const config = {
            latitude: latitude,
            longitude: longitude,
            key: vars.googleKey,
          }
          vm.gpsAddress = {
            location: {
              lat: latitude,
              lng: longitude,
            },
            direction: '',
          }
          geocoding.location(config, (err, data) => {
            if (err) {
              // console.log(err)
            } else {
              // console.log(data)
              vm.gpsAddress.direction = data.results[0].formatted_address
            }
          })
        })
      },
      setPlace (place) {
        const vm = this
        vm.address = place.formatted_address
        vm.selectedLat = place.geometry.location.lat()
        vm.selectedLng = place.geometry.location.lng()
        /* vm.loading = true
        const info = {
          latInicial: vm.arrCart.addressInfo.lat.toString(),
          lgnInicial: vm.arrCart.addressInfo.lng.toString(),
          dirInicial: vm.arrCart.addressInfo.addressgoogle,
          latFinal: vm.selectedLat.toString(),
          lgnFinal: vm.selectedLng.toString(),
          dirDestino: vm.address,
          idaRegreso: 'NO',
        }

        vm.$store.dispatch('delivery/deliveryCost', info).then((res) => {
          // console.log(res)
          if (res.success) {
            vm.arrCart.deliveryCost = res.costo
            vm.getDataCart()
            vm.loading = false
          }
        }) */
      },
      setDeliveryOption (type) {
        const vm = this
        if (type === 0) {
          vm.arrCart.delivery = 'delivery'
        } else if (type === 1) {
          vm.arrCart.delivery = 'pickup'
        } else {
          vm.arrCart.delivery = ''
        }
        vm.$forceUpdate()
      },
      getDeliveryOption (type) {
        const vm = this
        if (vm.arrCart.delivery === 'delivery') {
          vm.selectedDelivery = 0
        } else if (vm.arrCart.delivery === 'pickup') {
          vm.selectedDelivery = 1
        }
        vm.$forceUpdate()
      },
      sendOrder (cart) {
        const vm = this
        vm.loading = true
        const arrItems = []
        let totalPrice = 0
        for (let i = 0; i < cart.inventory.length; i++) {
          arrItems.push({
            amount: cart.inventory[i].amount,
            discount: '',
            id: cart.inventory[i].data.id,
            name: cart.inventory[i].data.name,
            ingredients: cart.inventory[i].data.ingredients || [],
            price: cart.inventory[i].data.price.sale,
            magnitude: cart.inventory[i].data.magnitude,
            unit: cart.inventory[i].data.unit,
            pricewithouttax: cart.inventory[i].data.price.salewithouttax || 0,
            purchase: cart.inventory[i].data.price.buy,
            pictures: cart.inventory[i].data.pictures,
            total: parseFloat(parseFloat(cart.inventory[i].amount) * parseFloat(cart.inventory[i].data.price.sale)).toFixed(2),
            type: cart.inventory[i].data.type,
          })
          totalPrice = totalPrice + parseFloat(parseFloat(cart.inventory[i].amount) * parseFloat(cart.inventory[i].data.price.sale))
        }
        if (vm.coupon !== null) {
          if (cart.id === vm.coupon.availableShop) {
            if (vm.coupon.isPorcentual) {
              totalPrice = (totalPrice * (100 - vm.coupon.value)) / 100
            } else {
              totalPrice = totalPrice - vm.coupon.value
              if (totalPrice < 0) {
                totalPrice = 0
              }
            }
          }
        }
        const referenceNumber = moment().valueOf()
        const time = moment().format()
        const cash = totalPrice.toFixed(2)

        const directionOrder = {
          direction: vm.address,
          location: {
            lat: +vm.selectedLat,
            lng: +vm.selectedLng,
          },
        }
        const data = {
          uid: cart.uid,
          data: {
            cash: cash,
            cashback: 0,
            id: '',
            items: arrItems,
            location_from: {
              id: cart.id,
              name: cart.name,
              pictures: cart.pictures,
              addressInfo: cart.addressInfo,
            },
            client: {
              direction: cart.delivery === 'delivery' ? directionOrder : 'No registra',
            },
            delivery: cart.delivery,
            reference_number: referenceNumber,
            referral: vm.referral,
            time: time,
            total: totalPrice.toFixed(2),
            type: 'orders',
            status: 'pending',
            origin: 'VIRTUAL-SHOP',
            method: vm.accounts[vm.account].type,
          },
        }
        // console.log(data, cart)
        // AQUI DEBO CAMBIAR EL ESTADO DEL CUPON
        if (vm.coupon) {
          if (data.data.location_from.id === vm.coupon.availableShop) {
            data.data.coupon = vm.coupon
            vm.$store.dispatch('promotions/changeStateCoupon', vm.coupon.id).then(() => {
              vm.$store.dispatch('promotions/deleteCoupon')
            })
          } else {
            Swal.fire({
              title: `El cupón que seleccionaste no esta disponible para 
                    la tienda ${data.data.location_from.name}`,
              text: '¿Desea continuar con esta orden?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Si, continuar',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.value) {
                vm.$store.dispatch('pos/sendOrder', data).then(() => {
                  // vm.allOrdersSent = vm.allOrdersSent + 1
                  vm.$store.dispatch('pos/removeOrder', cart).then(() => {
                    vm.getDataCart()
                    // if (vm.allOrdersSent === vm.ordersSize) {
                    vm.setDataNotification(true, 'success', 'Orden procesada.')
                    vm.loading = false
                    vm.$emit('closePayment')
                    // }
                  })
                })
              }
            })
          }
        } else {
          vm.$store.dispatch('pos/sendOrder', data).then(() => {
            // vm.allOrdersSent = vm.allOrdersSent + 1
            vm.$store.dispatch('pos/removeOrder', cart).then(() => {
              vm.getDataCart()
              // if (vm.allOrdersSent === vm.ordersSize) {
              Swal.fire({
                icon: 'success',
                title: 'Tu pedido ha sido enviado!',
                showCancelButton: true,
                confirmButtonColor: '#00CAE3',
                cancelButtonColor: '#A1E5AB',
                confirmButtonText: 'Ir a mis ordenes',
                cancelButtonText: 'Seguir comprando',
              }).then((result) => {
                if (result.value) {
                  vm.$router.replace('/my-requests')
                }
              })
              vm.loading = false
              vm.$emit('closePayment')
              // }
            })
          })
        }

        const clientData = {
          client: {
            direction: vm.$store.state.users.profile.direction ? vm.$store.state.users.profile.direction.address : 'No registra', // + ' ' + vm.$store.state.users.profile.direction.street,
            email: vm.$store.state.users.user.email,
            identification: vm.$store.state.users.profile.identification,
            name: vm.$store.state.users.profile.name + ' ' + vm.$store.state.users.profile.last_name,
            phone: vm.$store.state.users.profile.phone,
            sendBill: false,
          },
          userId: data.uid,
          context: 'marketplace',
        }
        vm.$store.dispatch('clients/addUpdateClient', clientData)
      },
      getPrice (item) {
        // console.log(item)
        if (item.data.price.wholesale && +item.amount >= +item.data.price.wholesale.amount) {
          if (item.data.price.wholesale.percentage) {
            return item.data.price.sale - ((+item.data.price.sale * (+item.data.price.wholesale.price / 100).toFixed(2)).toFixed(2))
          } else {
            return +item.data.price.sale - +item.data.price.wholesale.price
          }
        } else {
          return +item.data.price.sale
        }
      },
      updateAmount (index1, index2, idShop, product) {
        const vm = this
        const isNumber = /^[0-9]+([,.][0-9]+)?$/g.test(product.data.newAmount)
        const isAboveOne = product.data.newAmount >= 1
        if (isNumber && isAboveOne) {
          const newAmount = (parseFloat(product.data.newAmount)).toFixed(1)
          const hasMagnitude = !!product.data.magnitude
          product.data.validInputAmount = true
          if (parseFloat(newAmount) > parseFloat(product.amount)) {
            vm.$store.dispatch('pos/addAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
              vm.getDataCart()
            })
          } else if (parseFloat(newAmount) < parseFloat(product.amount)) {
            vm.$store.dispatch('pos/quitAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
              vm.getDataCart()
            })
          }
        } else {
          product.data.validInputAmount = false
        }
        vm.verifyAmounts()
      },
      verifyAmounts () {
        const vm = this
        vm.arrCart = this.$store.getters['pos/getCart']
        vm.allvalidInputAmount = true
        // for (let i = 0; i < vm.arrCart.length; i++) {
        for (let j = 0; j < vm.arrCart.inventory.length; j++) {
          if (!vm.arrCart.inventory[j].data.validInputAmount) {
            vm.allvalidInputAmount = false
          }
        }
        // }
        // vm.$emit('valid', allvalidInputAmount)
      },
      addReferralCoupon () {
        this.loadingReferral = true
        this.referralCode = this.referralCode.toUpperCase()
        this.$store.dispatch('promotions/referralValidator', { referralCode: this.referralCode, userCode: this.userProfile.referal_code }).then(() => {
          if (this.referral === '') {
            Swal.fire({
              icon: 'error',
              title: 'El codigo de referido ingresado no existe',
              timer: 4500,
            }).then(() => {
              this.loadingReferral = false
            })
          } else {
            let addingCoupon = true
            const posibleShopsToGetPromotion = this.cart.length
            let actualCart = 0
            while (addingCoupon && actualCart < posibleShopsToGetPromotion) {
              // console.log(addingCoupon, actualCart, posibleShopsToGetPromotion)
              const shopOwner = this.cart[actualCart].uid
              const shopId = this.cart[actualCart].id
              actualCart++
              const dataRequest = { shopOwner: shopOwner, shopId: shopId, isReferral: false, uid: '' }
              this.$store.dispatch('promotions/addFirstBuyCoupon', dataRequest).then(() => {
                if (this.addedCoupon) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Tu cupón ha sido agregado con exito',
                    timer: 7500,
                  }).then(() => {
                    addingCoupon = false
                  })
                } else if (!this.addedCoupon && actualCart === posibleShopsToGetPromotion) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Esta(s) tienda(s) no tiene la promoción de primera compra disponible',
                    timer: 7500,
                  })
                }
              }).finally(() => {
                if (this.addedCoupon || actualCart === posibleShopsToGetPromotion) {
                  this.loadingReferral = false
                  this.firstCouponDialog = false
                }
              })
            }
          }
        })
      },
      dontHaveReferral () {
        Swal.fire({
          icon: 'error',
          title: 'Para obtener el cupón de primera compra debes tener un referido',
        }).then(() => {
          this.firstCouponDialog = false
          this.referralCode = ''
        })
      },
      getAvailableCoupons () {
        this.loadingcoupons = true
        this.$store.dispatch('referrals/getAvailableCoupons').then(() => {
          // console.log(this.coupons)
          this.loadingcoupons = false
        })
      },
      saveSelectedCoupon () {
        if (this.selectedCoupon !== null) {
          const coupon = this.coupons[this.selectedCoupon]
          this.$store.dispatch('promotions/saveCoupon', coupon)
          this.getDataCart()
        } else {
          this.$store.dispatch('promotions/saveCoupon', this.coupon)
          this.getDataCart()
        }
        this.coupondialog = false
        this.referralCode = ''
      },
      deleteCoupon () {
        this.$store.dispatch('promotions/deleteCoupon')
        this.getDataCart()
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      clearCart () {
        this.$store.dispatch('pos/clearCart').then(() => {
          this.getDataCart()
        })
      },
      addAmount (index1, index2, idShop, product) {
        let newAmount
        if (product.data.magnitude) {
          newAmount = (parseFloat(product.data.newAmount) + 0.1).toFixed(1)
        } else {
          newAmount = (parseFloat(product.data.newAmount) + 1).toFixed(0)
        }
        const hasMagnitude = !!product.data.magnitude
        this.$store.dispatch('pos/addAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
          this.getDataCart()
        })
      },
      quitAmount (index1, index2, idShop, product) {
        let newAmount
        if (product.data.magnitude) {
          newAmount = (parseFloat(product.data.newAmount) - 0.1).toFixed(1)
        } else {
          newAmount = (parseFloat(product.data.newAmount) - 1).toFixed(0)
        }
        const hasMagnitude = !!product.data.magnitude
        this.$store.dispatch('pos/quitAmount', { index1, index2, idShop, newAmount, hasMagnitude }).then(() => {
          this.getDataCart()
        })
      },
      getDataCart () {
        const vm = this
        // vm.arrCart = this.$store.getters['pos/getCart'].filter(el => el.id === vm.currentShopId)[0]
        // console.log('cart ', vm.arrCart)
        vm.totalPrice = 0
        vm.totalProducts = 0
        // for (let i = 0; i < vm.arrCart.length; i++) {
        vm.arrCart.subtotal = 0 // agregado solo para la confirmacion de la orden
        // console.log(vm.arrCart.inventory.length, 'vm.arrCart.inventory.length')
        for (let j = 0; j < vm.arrCart.inventory.length; j++) {
          vm.arrCart.subtotal = (parseFloat(vm.arrCart.subtotal) + (parseFloat(vm.getPrice(vm.arrCart.inventory[j]))) * (parseFloat(vm.arrCart.inventory[j].amount))).toFixed(2)
          if (vm.arrCart.inventory[j].data.magnitude) {
            vm.totalProducts = parseFloat(vm.totalProducts) + 1
          } else {
            vm.totalProducts = (parseFloat(vm.totalProducts) + (parseFloat(vm.arrCart.inventory[j].amount)))
          }
        }
        vm.totalPrice += +vm.arrCart.subtotal
        // }
        if (vm.coupon !== null) {
          if (vm.coupon.isPorcentual) {
            vm.totalPrice = (vm.totalPrice * (100 - vm.coupon.value)) / 100
          } else {
            vm.totalPrice = vm.totalPrice - vm.coupon.value
            if (vm.totalPrice < 0) {
              vm.totalPrice = 0
            }
          }
        }
        vm.allAboveMinimum = true
        const minValue = +vm.arrCart.minOrderValue || 0
        if (+vm.arrCart.subtotal < minValue) {
          vm.allAboveMinimum = false
        }
        // vm.$emit('getcart')
        // console.log(vm.totalProducts, vm.totalPrice, 'productos precios')
        vm.$forceUpdate()
      },
      getImage (item) {
        if (item) {
          return item
        } else {
          return productPlaceHolder
        }
      },
      openBasket () {
        const vm = this
        vm.$store.dispatch('dialogs/openDialog', 'paymentWizDialog')
      },
    },
  }
</script>
<style lang="scss">
.input--google{
  width: 100%;
  border-bottom: solid;
  border-width: 1px;
  border-color: gray;
  margin: 0px !important;
  height: 30px;
  margin-top: 0px !important;
}

.basket {
  overflow-x: hidden;
  @media (min-width: 1024px) {
    min-height: 500px;
  }
  &__section {
    padding: 10px 0px 0px 5px;
    margin: 0px;
    max-width: 100%;
    overflow-x: hidden;
    max-height: 300px;
  }
  &__list {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    @media (min-width: 1024px) {
      max-height: 400px;
    }
  }
  &__background {
    .v-image__image {
      /*filter: blur(4px);*/
    }
  }
}
.shop-title {
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #1f7087;
}

.basket {
  &__continue-btn {
    position: relative;
    background-color: #009da5;
    border-radius: 10px;
    display: inline;
    width: 90%;
    text-align: center;
    padding: 15px 0;
    font-size: 1.4rem;
    font-weight: 400;
    color: #fff !important;
  }
  &__product-number {
    box-sizing: border-box;
    background-color: #05948d;
    position: absolute;
    padding: 0px 15px;
    top: 50%;
    left: 5%;
    font-size: 1.6rem;
    transform: translateY(-50%);
  }

  &__total {
    position: absolute;
    top: 50%;
    right: 5%;
    font-size: 1.6rem;
    transform: translateY(-50%);
  }
}
</style>
